import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output, SimpleChanges,
  ViewChild
} from '@angular/core';
import { Trade } from '../../../models/trade';
import { Direction } from '../../../models/direction';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-range-slider',
  templateUrl: './range-slider.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RangeSliderComponent),
      multi: true
    }
  ]
})
export class RangeSliderComponent implements OnInit, OnChanges, AfterViewInit, ControlValueAccessor, OnDestroy {

  value;
  @Input()
  trade: Trade;

  @ViewChild('myRange')
  myRange: ElementRef;

  @ViewChild('myValue')
  myValue: ElementRef;

  @Input()
  min = 0;

  @Input()
  max = 0;

  @Input()
  active: boolean;

  front = true;

  @Output()
  valueChange = new EventEmitter();

  zeroPoint: string;

  private position: number;

  private timer: any;

  propagateChange: any = () => {};
  propagateTouch: any = () => {};

  ngOnInit() {
    this.timer = setInterval(() => {
      if (this.active) {
        this.propagateChange(this.myRange.nativeElement.value);
      }
    }, 50);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.max && this.min && this.zeroPoint && this.myRange) {
      setTimeout(() => {
        this.init();
      }, 20);
    }
  }

  showAndPropagateSliderValue() {
    this.propagateChange(this.value);
    this.showSliderValue();
  }

  showSliderValue() {
    const width = this.myRange.nativeElement.offsetWidth - 64;
    this.myValue.nativeElement.style.left = this.calculateSliderTooltipPosition(this.calcBulletPosition(), width) + 'px';
  }

  calculateSliderTooltipPosition(bulletPosition, width) {
    const pos = bulletPosition * width;
    if (pos > width) {
      return width;
    } else if (pos < 0) {
      return 0;
    }
    return pos;
  }

  calcBulletPosition() {
    const max = Number(this.myRange.nativeElement.max);
    let min = Number(this.myRange.nativeElement.min);
    let value = Number(this.value);

    if (min < 0 && value < 0) {
      value = Math.abs(min) + value;
      min = Math.abs(min);
    } else if (min < 0) {
      min = Math.abs(min);
      value = Math.abs(min) + value;
    }
    let bulletPosition;
    if (Number(this.myRange.nativeElement.min) > 0) {
      value = value - min;
      bulletPosition = value / (max - min);
    } else {
      bulletPosition = value / (min  + max);
    }
    return bulletPosition;
  }

  setClasses() {
    let result = 'slider';
    if (this.trade.direction === Direction.LEND) {
      result += ' dirLend';
    } else {
      result += ' dirBorrow';
    }

    if (this.max === this.min) {
      return result;
    }

    if (this.value < this.min) {
      result += ' outOfRangeAtMin';
    } else if (this.value > this.max) {
      result += ' outOfRangeAtMax';
    }

    return result;
  }

  moveTooltip() {
    this.propagateChange(this.value);
    const width = this.myRange.nativeElement.offsetWidth;
    if (this.position > width) {
      // this.position = width - 11;
      this.position = width;
    } else if (this.position < 0) {
      this.position = 0;
    }
    this.myValue.nativeElement.style.left = this.position + 'px';
  }

  savePosition(event: MouseEvent) {
    this.position = event.offsetX;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    this.value = obj;
    if (this.myRange) {
      this.showSliderValue();
    }
  }

  ngAfterViewInit(): void {
    this.init();
    setTimeout(() => {
      this.showSliderValue();
    }, 100);
  }

  init() {
    const max = Number(this.myRange.nativeElement.max);
    let min = Number(this.myRange.nativeElement.min);
    let value = 0;

    if (min < 0 && value < 0) {
      value = Math.abs(min) + value;
      min = Math.abs(min);
    } else if (min < 0) {
      min = Math.abs(min);
      value = Math.abs(min) + value;
    }
    let bulletPosition;
    if (Number(this.myRange.nativeElement.min) > 0) {
      value = value - min;
      bulletPosition = value / (max - min);
    } else {
      bulletPosition = value / (min  + max);
    }
    setTimeout( () => {
      this.zeroPoint = bulletPosition * (this.myRange.nativeElement.offsetWidth - 32 - 30) + 30 + 'px';
    }, 10);
  }

  getCostLabel() {
    if (this.min > 0) {
      return '';
    }
    if (this.trade.direction === 'LEND') {
      return 'labelCost';
    }
    return 'labelEarning';
  }

  getEarningLabel() {
    if (this.max < 0) {
      return '';
    }
    if (this.trade.direction === 'BORROW') {
      return 'labelCost';
    }
    return 'labelEarning';
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }
}
